export default {
  translation: {
    appName: 'PetPro 商家儀表板',
    brand: 'PetPro',
    loading: '載入中…',

    range: {
      label: '時間範圍',
      last7: '過去 7 天',
      last30: '過去 30 天',
      last90: '過去 90 天',
    },

    stats: {
      occupancy: '住宿入住率',
      revenue: '實收營收',
      grossRevenue: '應收營收',
      bookings: '訂單數',
      avgPerNight: '平均 / 晚',
      thisRange: '本期',
    },

    lost: {
      headline: '本期少賺了 {{amount}}',
      detail: '{{nights}} 個空房晚數，平均房價 NT${{rate}}/晚。',
      hint: '（5C 階段：一鍵啟動「平日回流」LINE 行銷）',
      label: '本期未賺到的營收',
      subPattern: '{{empty}} 空房 / 共 {{total}} 房晚',
    },

    occupancy: {
      title: '入住率熱圖',
      empty: '此區間沒有住宿資料。',
      legendEmpty: '空房',
      legendFull: '滿房',
    },

    revenue: {
      title: '各服務營收',
      empty: '此區間沒有營收紀錄。',
      boarding: '寵物住宿',
      daycare: '日間托育',
      grooming: '美容',
      paid: '實收',
      gross: '應收',
      count: '筆',
    },

    channel: {
      title: '訂單來源',
      empty: '此區間沒有訂單。',
      own_site: '官方網站',
      line: 'LINE',
      google: 'Google',
      cherie: 'Cherie',
      staff: '門市/電話',
      phone: '電話',
      unknown: '其他',
    },

    richMenu: {
      title: 'LINE 選單',
      sub: '釘在 LINE 聊天室底部的圖文選單。可用品牌設定自動產生，或上傳自家設計。',
      notConnected: '請先連接您的 LINE 官方帳號（設定 → LINE）才能使用圖文選單。',
      statusProvisioned: '選單已上線（{{when}}）',
      statusMode_generated: '自動產生',
      statusMode_custom: '自訂設計',
      statusNone: '尚未套用選單。',
      brandingHint: '更改過 Logo 或品牌色？重新套用選單，LINE 才會顯示新樣式。',
      modeGenerated: '自動產生',
      modeGeneratedHint: '以您的 Logo 與品牌色自動繪製，零設計成本。',
      modeCustom: '自訂設計',
      modeCustomHint: '設計師依範本製作的完整視覺，品牌感最強。',
      apply: '套用選單',
      reapply: '重新套用',
      applying: '套用中…',
      remove: '移除選單',
      layout: '版型',
      template: '下載設計範本',
      templateHint: '交給您的設計師 — 圖檔必須完全符合範本（{{w}}×{{h}}px、PNG/JPEG、≤1MB）。',
      upload: '上傳設計圖',
      uploading: '上傳中…',
      replace: '更換設計圖',
      zoneActions: '點擊動作',
      zone: '區塊 {{n}}',
      actionPortal: '入口頁面',
      actionChat: '開啟聊天',
      actionUrl: '外部連結',
      tab_status: '寵物近況',
      tab_report: '每日報告',
      tab_contact: '聯繫工作人員（聊天）',
      tab_reservations: '下次住宿',
      tab_book: '再次預約',
      tab_info: '設施資訊',
      urlPlaceholder: 'https://…',
      chatBar: '選單列文字',
      chatBarHint: '收合時選單列顯示的文字（最多 14 字）。',
      saveConfig: '儲存設計',
      saved: '設計已儲存。',
      applyCustom: '儲存並套用選單',
      needImage: '請先上傳設計圖。',
      wrongSize: '此版型的圖檔必須是 {{w}}×{{h}}px（目前為 {{gw}}×{{gh}}px）。',
      tooBig: '圖檔超過 1MB，LINE 會拒絕。請降低輸出品質後再試。',
      applied: '選單已套用 — 請到 LINE 聊天室查看。',
      removed: '選單已移除。',
      revert: '改回自動產生',
      previewHint: '疊層顯示點擊區塊，點擊會執行各區塊設定的動作。',
    },
    bookingPage: {
      title: '線上預約頁面',
      sub: '一鍵讓客人在 Google 上找到您的店家、直接預約。',
      stateLive: '已上線：',
      stateNoSlug: '請設定一個網址，才能發佈預約頁面。',
      stateDisabled: '預約頁面目前「關閉」中，開啟後即可開始接單。',
      stateReady: '已準備好上線 — 切換開關即可發佈。',
      slugLabel: '頁面網址',
      slugHint: '可用小寫英文、中文、數字、連字號。建議短而好記。',
      slugPlaceholder: '例如：furkid-home 或 毛孩之家',
      slugTaken: '此網址已被使用，請改用其他名稱。',
      slugFormat: '須為 2–40 個字元；小寫英文 / 中文 / 數字 / 連字號；不能以連字號開頭或結尾。',
      enabled: '預約頁面公開',
      enabledHint: '開啟後，任何人都能找到並預約您的店家。',
      englishEnabled: '同時發佈英文版',
      // SHARED-1 feature toggles
      featuresHeading: '功能',
      addOnsEnabled: '預約加購',
      addOnsHint:
        '讓客戶在預約確認頁勾選加購項目（如剪指甲、洗毛精等）。完成服務後於現場結帳。',
      photoCardsEnabled: '寵物紀念卡',
      photoCardsHint:
        '服務結束後，員工可透過 LINE 發送品牌化的前後對比照給客戶。需客戶於預約時同意。',
      taxInclusive: '價格已含稅 (台灣 B2C 慣例)',
      taxInclusiveHint:
        '開啟時，您輸入的價格已包含 5% 營業稅 (台灣消費端標準)。關閉時，發票會另外加上 5%。',
      requireDeposit: '預約需付訂金',
      requireDepositHint:
        '開啟後，線上預約會先保留為「待確認」，收到訂金才自動確認。這是最有效的防止放鳥方式。',
      depositPercent: '訂金比例',
      depositPercentHint: '以預估總金額計算。例如總額 NT$2,000、訂金 30% 即為 NT$600。',
      depositGatewayReady: '✓ 已串接線上收款（綠界），客人可於預約時直接線上支付訂金。',
      depositLink: '收款連結（尚未串接線上金流）',
      depositLinkHint:
        '尚未開通線上刷卡，請貼上您自己的收款連結（LINE Pay／銀行轉帳說明），系統會在預約後傳給客人。',
      englishHint: '新增 /<slug>/en 英文替代頁面（Google 與國際訪客可見）。',
      displayNameZh: '店家名稱（中文）',
      displayName: '店家名稱（英文，選填）',
      taglineZh: '標語（中文）',
      tagline: '標語（英文，選填）',
      save: '儲存設定',
      saving: '儲存中…',
      saved: '已儲存',
      visit: '前往頁面',
      copy: '複製網址',
      copied: '已複製！',
      // Phase 6A.5 — identity pack
      identityHeading: '品牌與識別',
      identitySub: '上傳商標、照片與影片，讓預約頁看起來就是您的店家，而不是我們的。',
      logo: '商標',
      logoHint: '方形最理想。支援 PNG / JPG / WebP，最大 8 MB。',
      logoAlt: '商家商標',
      accentColor: '品牌主色',
      accentColorHint: '會套用在預約頁的標題與按鈕。',
      gallery: '照片相簿',
      galleryHint: '最多 8 張。第一張會成為主視覺封面。',
      addPhoto: '新增照片',
      removePhoto: '移除',
      uploading: '上傳中…',
      uploadFailed: '上傳失敗，請再試一次。',
      uploadTooLarge: '檔案超過 8 MB，請選擇較小的圖片。',
      uploadBadType: '只接受 JPG、PNG、WebP 或 GIF。',
      video: '介紹影片',
      videoHint: '貼上 YouTube 或 Vimeo 連結，會自動嵌入預約頁。',
      videoPlaceholder: 'https://youtube.com/watch?v=…',
      videoClear: '移除影片',
    },

    marketing: {
      title: '行銷 — 一鍵發送',
      subtitle: '一鍵將既有名單轉換成 LINE 行銷活動。',
      empty: '目前沒有可聯絡的客戶名單，請先連結 LINE 官方帳號。',
      lapsedTitle: '回流客戶',
      lapsedHook: '{{count}} 位客戶超過 60 天沒有預約。',
      lapsedCta: '發送 LINE 回流訊息',
      seasonalTitle: '節慶推播',
      seasonalHook: '{{count}} 位活躍客戶，可推播節慶優惠。',
      seasonalCta: '撰寫節慶訊息',
      comingSoon: '組合工具即將推出',
      confirmTitle: '確認發送 LINE 回流活動',
      confirmRecipients: '本次將寄給 {{count}} 位客戶。',
      confirmMessageLabel: '訊息內容',
      confirmSampleLabel: '客戶範例',
      cancel: '取消',
      send: '立即發送',
      sending: '發送中…',
      sentToast: '已寄出至 {{count}} 位客戶',
      defaultMessage:
        '哈囉 {{ownerName}}！好久不見，希望很快能再見到 {{petName}}～月底前回來預約享 9 折優惠！',
    },

    assistant: {
      fab: '助理',
      title: '商家成長助理',
      sub: '唯讀模式 · 依據您的即時資料回答',
      placeholder: '問我入住率、營收、訂單來源、回流名單…',
      send: '送出',
      thinking: '思考中…',
      emptyHint: '範例提問：',
      suggestions: [
        '我的訂單主要來自哪些通路？',
        '60 天內沒回流的客戶有幾位？',
        '本期我少賺了多少？',
      ],
      toolsUsed: '已讀取 {{count}} 項資料',
      close: '關閉',
    },

    auth: {
      mock: '示範資料',
      logout: '登出',
      loginTitle: '登入 PetPro 商家儀表板',
      loginSubtitle: '請選擇一種登入方式。',
      tokenLabel: '存取權杖（JWT）',
      tokenHint: '權杖由 PetPro 客服在開通時提供。',
      enter: '進入儀表板',
      // Phase 6B — primary login paths
      continueWithLine: '使用 LINE 繼續',
      signInWithEmail: '使用 Email 登入',
      firstTimeHint: '第一次登入嗎？請使用 LINE，並準備好 PetPro 提供的 6 位數啟用碼。',
      advancedJwt: '進階：使用存取權杖登入',
      advancedJwtHint: '此入口僅供 PetPro 客服與內部測試使用。一般商家請使用上方的 LINE 或 Email 登入。',
      // /login/email
      email: {
        title: '使用 Email 登入',
        sub: '我們會寄一個一次性登入連結到您的信箱。',
        sentSub: '已寄信至 {{email}}，請查收。',
        label: '商家 Email',
        send: '寄送登入連結',
        inboxHint: '請檢查您的信箱（包括垃圾郵件夾）。連結 15 分鐘內有效，僅可使用一次。',
        sameBrowserHint: '為了安全，請在「送出登入請求的同一個瀏覽器」點擊連結。',
        resend: '重新寄送',
        resendIn: '{{seconds}} 秒後可重寄',
        firstTimeHint: '收不到信？第一次登入請改用 LINE 並輸入啟用碼。',
        back: '返回登入',
      },
      // /login/claim
      claim: {
        title: '啟用您的商家帳號',
        welcomeNamed: '您好 {{name}}！',
        welcomeAnon: '歡迎使用 PetPro 商家儀表板。',
        noEmail: '（LINE 未提供 Email）',
        codeLabel: '6 位數啟用碼',
        codeHint: '啟用碼由 PetPro 客服在開通時提供（CCxxxx 編號為客服參考用）。',
        submit: '啟用並進入儀表板',
        noCodeHint: '沒有啟用碼？請聯絡 PetPro 客服。',
        formatError: '請輸入 6 位數字。',
      },
      // Callback waiting
      callback: {
        signingIn: '登入中…',
      },
      // Error reasons surfaced via ?error=… on the login URL.
      error: {
        generic: '登入失敗，請重試。',
        state: '登入流程已過期，請重新登入。',
        channel: 'LINE 登入暫時無法使用，請改用 Email 登入。',
        exchange: 'LINE 驗證失敗，請重試。',
        browser_mismatch: '請在「送出登入請求的同一個瀏覽器」點擊連結。',
        expired: '此登入連結已過期，請重新申請。',
        used: '此登入連結已使用過，請重新申請。',
        invalid: '無效的登入連結。',
      },
    },

    errors: {
      generic: '發生未預期錯誤，請稍後再試。',
      network: '連線異常，請檢查網路後重試。',
      unauthorized: '登入逾期，請重新登入。',
    },

    policies: {
      title: '智慧客服 · 店家政策/FAQ',
      subtitle: 'LINE 智慧客服只會根據這裡的內容回答政策問題；沒有相關條目時會轉給真人，不會亂編。',
      questionLabel: '客人常問的問題',
      questionPlaceholder: '例如：可以帶自己的飼料嗎？',
      answerLabel: '您的回答',
      answerPlaceholder: '例如：可以喔！入住時請附上餵食說明。',
      addButton: '新增問答',
      added: '已新增',
      empty: '還沒有任何問答。新增幾條常見問題，智慧客服就能替您回答！',
      loadFailed: '無法載入問答',
      saveFailed: '儲存失敗，請再試一次',
      deleteConfirm: '確定要刪除這條問答嗎？',
      activeToggle: '啟用',
      delete: '刪除',
    },

    packages: {
      // Phase A1a — 套票管理（唯讀目錄）
      navLink: '套票',
      title: '服務套票',
      back: '返回儀表板',
      loading: '載入中…',
      editingComingSoon: '編輯功能即將推出 — 目前為唯讀檢視。',
      offerings: {
        title: '套票方案',
        subtitle: '預付的次卡：客戶可預先購買美容、日托或住宿次數。',
        cardTitle: '您的套票',
        count_one: '{{count}} 個上架中 · {{archived}} 個已封存',
        count_other: '{{count}} 個上架中 · {{archived}} 個已封存',
        countSimple_one: '{{count}} 個套票',
        countSimple_other: '{{count}} 個套票',
      },
      filter: {
        allServices: '全部服務類型',
        includeArchived: '包含已封存',
      },
      serviceType: {
        boarding: '住宿',
        daycare: '日托',
        grooming: '美容',
      },
      card: {
        defaultPrice: '預設價格',
        validity: '有效期',
        validityValue: '{{days}} 天',
        refund: '退款政策',
        transferability: '可分享性',
        archived: '已封存 — 客戶看不到此套票',
      },
      refundPolicy: {
        none: '不可退款',
        prorated: '按使用次數比例退款',
        prorated_with_fee: '比例退款 - 提早終止費用',
        full_within_window: '期限內全額退款',
      },
      transferability: {
        household: '家庭套票（同帳戶所有寵物可用）',
        owner_only: '指定寵物',
      },
      empty: {
        title: '尚未建立套票',
        subtitle: '建立第一個預付套票，鎖定客戶營收。',
        comingSoon: '編輯功能即將推出 — 可請客服協助開通。',
      },
      errors: {
        loadFailed: '無法載入套票，請稍後再試。',
      },
      dashboardTile: {
        label: '套票銷售',
        expiringWithin7d_one: '{{count}} 個 7 日內到期',
        expiringWithin7d_other: '{{count}} 個 7 日內到期',
      },
      redemptions: {
        title: '兌換紀錄',
        includeVoided: '顯示已作廢',
        einvoiceWarning:
          'Camus 已為每筆兌換開立統一發票 — 請勿重複開立。',
        empty: '尚無兌換紀錄。',
        colWhen: '時間',
        colService: '服務',
        colKind: '類別',
        colSessions: '次數',
        colActions: '操作',
        kindRedeem: '兌換',
        kindRestore: '還原',
        kindVoided: '已作廢',
        undoBtn: '撤回',
        restoreBtn: '還原點數',
        undoReasonPrompt: '撤回原因（稽核用）：',
        errors: {
          ERROR_PACKAGES_VOID_WINDOW_EXPIRED:
            '已超過 24 小時撤回期，請改用「還原點數」。',
          load_failed: '無法載入兌換紀錄。',
          void_failed: '撤回失敗。',
        },
      },
      restore: {
        title: '還原次數點數',
        subtitle:
          '適用於 24 小時撤回期之後的早離店。原兌換紀錄保留；新增一筆補償性「還原」紀錄將未使用的次數歸還。',
        original: '原扣抵次數',
        sessionsUsedSuffix: '次',
        serviceType: '服務',
        sessionsToRestore: '還原次數',
        sessionsHelp: '最多 {{max}} 次；將顯示為 +N 的紀錄。',
        reasonLabel: '原因（稽核用）',
        reasonPlaceholder: '例如：客戶提早一晚接走狗狗',
        cancel: '取消',
        confirm: '還原點數',
        errors: {
          sessions_must_be_positive: '至少需還原 1 次。',
          sessions_exceed_consumed: '還原次數不可超過原本使用次數。',
          reason_required: '必填稽核原因。',
          ERROR_PACKAGES_RESTORE_EXCEEDS_CONSUMED:
            '還原次數不可超過原本使用次數。',
          restore_failed: '還原失敗。',
        },
      },
      priceChange: {
        impactTitle: '提醒：此變更會影響：',
        activeOnOldPrice_one: '{{count}} 位客戶持有舊價格套票',
        activeOnOldPrice_other: '{{count}} 位客戶持有舊價格套票',
        pendingCheckouts_one: '{{count}} 筆結帳進行中',
        pendingCheckouts_other: '{{count}} 筆結帳進行中',
        oldPriceHonored:
          '既有客戶保留舊價格（快照機制）。',
        lastSale: '最後銷售：{{days}} 天前',
        noSales: '此級距尚無銷售。',
      },
      addOns: {
        title: '加購項目',
        subtitle:
          '客戶在預約時可勾選的小型加購服務 — 剪指甲、洗毛精、延後退房等。完成服務後於現場結帳。',
        empty: '尚未建立任何加購項目。',
        emptyCta: '建立第一個加購',
        addBtn: '新增加購',
        colName: '名稱',
        colPrice: '價格',
        colCategory: '類別',
        colApplicableTo: '適用服務',
        colStatus: '狀態',
        colActions: '操作',
        statusActive: '上架中',
        statusInactive: '已下架',
        editBtn: '編輯',
        deleteBtn: '刪除',
        deleteConfirm: '確定刪除此加購？已存在的預約仍會保留快照。',
        loading: '載入中…',
        loadFailed: '無法載入加購項目。',
        category: {
          grooming: '美容',
          wellness: '保健',
          retail: '商品',
          other: '其他',
        },
        service: {
          boarding: '住宿',
          daycare: '日托',
          grooming: '美容',
        },
        editor: {
          createTitle: '新增加購項目',
          editTitle: '編輯加購項目',
          nameLabel: '名稱（英文）',
          nameZhLabel: '名稱（中文）— 客戶看到的版本',
          categoryLabel: '類別',
          priceLabel: '價格（NT$，含稅）',
          pricingTypeLabel: '計價方式',
          pricingType: {
            per_session: '每次',
            per_night: '每晚',
            one_time: '單次',
          },
          durationLabel: '所需時間（分鐘，選填）',
          applicableLabel: '適用服務類型',
          notesLabel: '內部備註（選填）',
          retailInventoryHint:
            'v1 暫不追蹤庫存 — 售完時請手動關閉「上架中」。',
          activeLabel: '上架中',
          cancel: '取消',
          save: '儲存',
          required: '必填',
          priceMustBePositive: '價格必須大於 0',
          mustPickAtLeastOneService: '至少需選擇一個適用服務。',
        },
      },
      outstanding: {
        title: '已售套票',
        summary_one: '{{count}} 個套票將於 14 日內到期 · 帳面價值 {{total}}',
        summary_other: '{{count}} 個套票將於 14 日內到期 · 帳面價值 {{total}}',
        statusAll: '全部狀態',
        statusActive: '使用中',
        statusExhausted: '已用完',
        statusRefunded: '已退款',
        expiringBanner_one: '{{count}} 個套票將在 14 日內到期，建議聯繫客戶。',
        expiringBanner_other: '{{count}} 個套票將在 14 日內到期，建議聯繫客戶。',
        empty: '尚無客戶購買紀錄。',
        colPackage: '套票',
        colRemaining: '剩餘',
        colPaid: '已付',
        colExpires: '到期',
        colStatus: '狀態',
        colActions: '操作',
        refundedAmount: '−{{amount}} 已退',
        daysLeft_one: '{{days}} 天',
        daysLeft_other: '{{days}} 天',
        refundBtn: '退款',
        status_active: '使用中',
        status_exhausted: '已用完',
        status_expired: '已過期',
        status_refunded: '已退款',
        status_cancelled: '已取消',
        status_disputed: '爭議中',
      },
      refund: {
        title: '套票退款',
        previewFailed: '無法計算退款金額。',
        formula: '退款計算',
        paid: '已付金額',
        fee: 'Stripe 手續費',
        consumed: '已用 {{sessions}} 次 × {{unit}}',
        alreadyRefunded: '已退款',
        allowed: '可退款金額',
        amountLabel: '退款金額（{{currency}}，最小單位）',
        reasonLabel: '退款原因（必填，稽核用）',
        reasonPlaceholder: '例如：客戶搬家',
        cancel: '取消',
        confirm: '確認退款',
        errors: {
          amount_must_be_positive: '退款金額需大於 0。',
          amount_exceeds_allowed: '超過政策允許上限。',
          reason_required: '必須填寫退款原因。',
          packages_purchase_disputed: '此筆有爭議，請直接在 Stripe 處理。',
          packages_already_refunded: '已全額退款。',
          refund_failed: '退款失敗，請再試一次。',
        },
      },
      editor: {
        titleCreate: '新增套票方案',
        titleEdit: '編輯套票方案',
        subtitle: '設定預付套票與級距。客戶一次付款，每次預約自動扣抵。',
        tierPreview: '級距預覽：',
        newPackage: '新增套票',
        editButton: '編輯',
        archiveButton: '封存',
        restoreButton: '還原',
        serviceType: '服務類型',
        serviceTypeLocked: '已有客戶購買後，服務類型無法變更。',
        nameEn: '名稱（英文）',
        nameZh: '名稱（中文）',
        descEn: '說明（英文）',
        descZh: '說明（中文）',
        basePriceMinor: '基準價（最小單位）',
        basePriceHint: '使用最小幣值單位。NT$4,500 = 450000。',
        validityDays: '有效天數',
        transferability: '可分享性',
        einvoiceRequired: '結帳時需提供統一發票資料',
        refundMode: '退款政策',
        refundWindowDays: '可退款天數',
        refundFeeMinor: '提早終止費用（最小單位）',
        article19Warning:
          '不可退款方案可能不符消保法第 19 條（網路販售 7 日內無條件退換）。請務必在結帳頁顯示條款。',
        tierLadder: '級距階梯',
        tierLadderHint:
          '付費次數需嚴格遞增，請選一個預設級距（選項按鈕）。',
        defaultTier: '預設級距',
        paidSessions: '付費次數',
        bonusSessions: '加贈次數',
        priceMinor: '價格（最小單位）',
        unitCost: '每次 NT${{unit}} × 共 {{total}} 次',
        addTier: '新增級距',
        removeTier: '移除級距',
        cancel: '取消',
        saveNew: '建立套票',
        saveExisting: '儲存變更',
        errors: {
          name_required: '中文與英文名稱皆為必填。',
          price_negative: '基準價不可為負。',
          tiers_required: '至少需設定一個級距。',
          tier_paid_min: '付費次數至少為 1。',
          tier_ascending: '付費次數需嚴格遞增。',
          tier_price_negative: '級距價格不可為負。',
          package_name_duplicate: '已有同名英文套票。',
          package_tiers_max_exceeded: '每個套票最多 6 個級距。',
        },
      },
    },

    billing: {
      banner: {
        past_due: '訂閱已過期 — 服務暫時繼續中',
        canceled: '訂閱已停用 — 寫入功能已暫停，僅能瀏覽',
        suspended: '帳號已停權 — 請完成付款以恢復使用',
        graceLeft: '還有 {{days}} 天緩衝期',
        payNow: '立即付款',
        dismiss: '關閉',
      },
      state: {
        active: '使用中',
        trialing: '試用中',
        comped: '贊助中',
        past_due: '逾期未繳',
        canceled: '已停用（唯讀）',
        suspended: '已停權',
        deleted: '已關閉',
      },
      page: {
        title: '訂閱與付款',
        sub: '管理您的 PetPro 訂閱、付款方式與付款記錄。',
        back: '返回儀表板',
        currentPlan: '目前方案',
        tier: '方案',
        status: '狀態',
        paidThrough: '已付款至',
        trialEnds: '試用結束',
        graceLeft: '還有 {{days}} 天緩衝期可完成付款',
        unknown: '尚未取得訂閱資訊',
        payOptions: '付款方式',
        payOptionsSub: '選擇適合您的付款方式。匯款後客服將於 1 個工作天內標記為已付款。',
        stripeTitle: '線上信用卡（Stripe）',
        stripeSub: '使用信用卡付款 — 即時開通。',
        stripeComingSoon: '即將推出 — 目前請使用下方的銀行匯款方式。',
        stripePay: '使用信用卡付款',
        stripeRedirecting: '重新導向中…',
        // 訂閱方案層級（h8i9j0k1l2m3）
        tierStarter: '入門',
        tierProfessional: '專業',
        tierHospital: '醫院',
        tierSolo: '單人',
        tierSmall: '小型',
        tierPro: '專業',
        cycleMonthly: '月繳',
        cycleAnnual: '年繳',
        saveAnnualBadge: '省約 17%',
        year: '年',
        notAvailable: '尚未開放',
        promoLabel: '優惠代碼（選填）',
        promoApply: '套用',
        promoChecking: '檢查中…',
        promoSavings: '節省 NT${{amount}}（折扣後 {{net}}）',
        promoInvalid: '代碼無效或不適用。',
        promoRateLimit: '嘗試次數過多，請稍候再試。',
        promoGenericError: '無法驗證代碼。',
        pricingFetchFailed: '無法載入方案 — 請重新整理。',
        manualTitle: '銀行匯款 / ATM',
        manualInstructions: '請使用下列帳戶完成匯款。匯款時請於備註欄填寫您的店家名稱，並於完成後通知 PetPro 客服（LINE @petpro）。',
        bankName: '銀行',
        bankNameValue: '第一銀行（007）',
        bankAccount: '帳號',
        bankAccountValue: '23410089931',
        bankBeneficiary: '戶名',
        bankBeneficiaryValue: '卡繆科技有限公司',
        manualFootnote: '匯款後客服會於 1 個工作天內處理並為您續期訂閱。如急需開通，請來電 02-XXXX-XXXX。',
        history: '付款記錄',
        historyHidden: '訂閱已停權 — 完成付款後可查看記錄。',
        noHistory: '尚無付款記錄。',
        colDate: '記錄日期',
        colPeriod: '付款期間',
        colMethod: '付款方式',
        colAmount: '金額',
      },
    },
  },
}
